import { HTTP } from './http_service';

export const createPoster = function(fields) {
  return HTTP.post('/online/posters', fields).then((response) => {
    return response.data;
  });
};

export const updatePoster = function(poster_id, fields) {
  fields._method = 'PUT';
  return HTTP.post('/online/posters/' + poster_id, fields).then((response) => {
    return response.data;
  });
};

export const fetchPoster = function(poster_id) {
  return HTTP.post('/online/poster-filler/poster/' + poster_id).then((response) => {
    return response.data;
  });
};

export default {
  createPoster,
  updatePoster,
  fetchPoster,
};



// WEBPACK FOOTER //
// ./resources/assets/js/components/services/poster_service.js